import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CultureFacade } from '@boels/shared-state';

@Component({
  selector: 'boels-privacy-statement-link',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './privacy-statement-link.component.html',
  styleUrl: './privacy-statement-link.component.scss',
})
export class PrivacyStatementLinkComponent implements OnInit {
  private cultureFacade = inject(CultureFacade);

  public privacyStatementUrl$: Observable<string>;

  ngOnInit() {
    this.privacyStatementUrl$ = this.cultureFacade
      .getActiveCulture()
      .pipe(map((culture) => `/${culture}/privacy-statement`));
  }
}
